import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["imageItem", "nextButton"];

  connect() {
    this.selectedImageUrl = null;
    this.selectedImageableId = null;
    this.selectedImageableType = null;
  }

  selectImage(event) {
    this.imageItemTargets.forEach(item => item.classList.remove("selected"));

    const selectedItem = event.currentTarget;
    selectedItem.classList.add("selected");

    const imageLink = selectedItem.querySelector("a");
    this.selectedImageUrl = imageLink.dataset.imageUrl;
    this.selectedImageableId = imageLink.dataset.id;
    this.selectedImageableType = selectedItem.dataset.imageableType;
    this.selectedImageContentType = imageLink.dataset.fileContentType;

    if (!this.selectedImageableType) {
      console.error("Missing data-imageable-type attribute on selected item.");
      return;
    }

    this.nextButtonTarget.style.display = "block";
  }

  nextStep() {
    if (this.selectedImageUrl && this.selectedImageableId && this.selectedImageableType) {
      const customEvent = new CustomEvent("imageSelected", {
        detail: {
          imageUrl: this.selectedImageUrl,
          imageableId: this.selectedImageableId,
          imageableType: this.selectedImageableType,
          imageContentType: this.selectedImageContentType,
          position: this.element.dataset.position,
        },
      });
      window.dispatchEvent(customEvent);

      if (window.modal && typeof window.modal.close === "function") {
        window.modal.close();
      }
    }
  }

  selectImageAndClose(event) {
    this.selectImage(event);
    this.nextStep();
  }
}
